/** @jsx jsx */
import { jsx } from 'theme-ui';

import { Box } from 'theme-ui';
import { useStaticQuery, graphql } from 'gatsby';

import MainPageCarousel from '@gatsbystorefront/gatsby-theme-storefront-shopify/src/templates/main/MainPageCarousel';
import MainPageSection from '@gatsbystorefront/gatsby-theme-storefront-shopify/src/templates/main/MainPageSection';
import MainPageFeaturedCollectionBlock from '@gatsbystorefront/gatsby-theme-storefront-shopify/src/templates/main/MainPageFeaturedCollectionBlock';

const MainPage = (props) => {
  const dataQuery = useStaticQuery(graphql`
    query ShadowedMainPageStaticQuery {
      site {
        siteMetadata {
          gatsbyStorefrontConfig {
            mainPage {
              handle
              type
              name
              description
              limit
              isExpanded
              textBgColor
              textColor
              buttonText
              buttonTextColor
              buttonBgColor
              children {
                handle
                type
                name
                description
                limit
                isExpanded
                textBgColor
                textColor
                buttonText
                buttonTextColor
                buttonBgColor
              }
            }
          }
        }
      }
    }
  `);

  const { mainPage } = dataQuery.site.siteMetadata.gatsbyStorefrontConfig;

  const { data } = props;

  const { cartUrl } = props.pageContext;

  // CHECK IF MOBILE
  let isMobile = false;
  let mainDisplay = 'flex';
  let sectionWidth = '50%';

  if (typeof window !== 'undefined') {
    isMobile = window.innerWidth < 450;
  }

  console.log('isMobile: ' + isMobile);

  if(isMobile) {
    mainDisplay = 'block';
    sectionWidth = '100%';
  }

  return (

    <Box px={2} pt={3} mx="auto" style={{
      maxWidth: 1300,
      display: mainDisplay
    }}>
      {mainPage.map((block, index) => {
        if (block.type === 'carousel') {
          return (
            <Box sx={{ width: '100%' }} mb={1} key={index}>
              <MainPageCarousel carousel={block} data={data} />
            </Box>
          );
        } else if (block.type === 'section') {
          return (
            <Box sx={{ width: sectionWidth }} mb={1} key={index}>
              <MainPageSection section={block} data={data} />
            </Box>
          );
        } else if (
          block.type === 'product' ||
          (block.type === 'collection' && block.isExpanded === false)
        ) {
          return (
            <Box sx={{ width: '100%' }} mb={1} key={index}>
              <MainPageSection section={{ children: [block] }} data={data} />
            </Box>
          );
        } else if (block.type === 'collection' && block.isExpanded === true) {
          let products = [];
          props.data.feauturedCollections.nodes.forEach((node) => {
            if (node.handle === block.handle && node.products) {
              products = [...products, ...node.products];
            }
          });
          return (
            <MainPageFeaturedCollectionBlock
              block={block}
              products={products}
              cartUrl={cartUrl}
              key={index}
            />
          );
        } else if (block.type === 'header') {
          return '';
        } else {
          return '';
        }
      })}
    </Box>
  );
};

export default MainPage;
